import { useFilingCabinetContext } from '@/Contexts/Authenticated/FilingCabinetContext';
import type { FilingCabinetItem } from '@/Models/FilingCabinet/FilingCabinet';
import { ListItemButton } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import Styles from '../FilingCabinetItemLink/FilingCabinetItemLink.module.scss';

export interface FilingCabinetItemLinkProps {
    item: FilingCabinetItem;
}

const FilingCabinetItemLink = ({ item }: FilingCabinetItemLinkProps): React.ReactElement => {
    const {
        removeFromFilingCabinet,
        openExisting,
    } = useFilingCabinetContext();

    const { active, title } = item;

    const handleCloseFilingCabinetItem = (event: React.MouseEvent): void => {
        event.stopPropagation();
        event.preventDefault();

        void removeFromFilingCabinet(item);
    };

    const classes = classNames(Styles.filingCabinetItem, {
        [`active`]: active,
        inactive: !active,
    });

    return (
        <ListItemButton className={classes} onClick={() => openExisting(item)} divider>
            <span className={Styles.title}>{title}</span>
            { item.isLocked && <span className="material-symbols-outlined">lock</span> }
            <span className={Styles.icons}>
                <span className="material-symbols-outlined icon" onClick={handleCloseFilingCabinetItem}>do_not_disturb</span>
            </span>
        </ListItemButton>
    );
};

export default FilingCabinetItemLink;
